import { observable, action } from 'mobx';

import { SourceHotelReview } from 'sletat-api-services/lib/ui/hotelReviews/models/hotel-reviews';

import { TabsType } from '../../models/post-filters';
import {
    AdaptiveType,
    SearchFormAdaptiveType,
    PostFiltersAdaptiveType,
    HotelRoomsAdaptiveType,
} from '../../models/adaptive';
import { HotelTabs } from '../../models/tabs';
import {
    getAdaptiveType,
    getSearchFormAdaptiveType,
    getPostFiltersAdaptiveType,
    getHotelRoomsAdaptiveType,
} from '../../utils/adaptive';

import { NotificationStore } from './notification';


export class UiStore {

    // TODO: check and remove all unnecessary things that depend on it
    notification = new NotificationStore();

    @observable
    currentHotelTab: HotelTabs = HotelTabs.Tours;

    @observable
    currentHotelReviewTab: SourceHotelReview = SourceHotelReview.TripAdvisor;

    @observable
    isPostfilterMenuVisible: boolean = false;

    @observable
    isHotelDescriptionOpen: boolean = false;

    @observable
    adaptiveType = getAdaptiveType();

    @observable
    searchFormAdaptiveType = getSearchFormAdaptiveType();

    @observable
    postFiltersAdaptiveType = getPostFiltersAdaptiveType();

    @observable
    hotelRoomsAdaptiveType = getHotelRoomsAdaptiveType();

    @observable
    isExtraPayPopupVisible: boolean = false;

    @observable
    isExtraPayPopupCloseTimerActive: boolean = false;

    @observable
    selectedPostFilterTab: TabsType = TabsType.RoomTypes;

    @observable
    isHotelOnMapOpen: boolean = false;

    @observable
    isHotelFacilitiesOpen: boolean = false;

    @observable
    isModalFiltersOpen: boolean = false;

    @observable
    openPopupRoomId: number | null = null;

    private extraPayPopupTimer: number = 0;


    @action
    setModalFiltersOpen(state: boolean): void {
        this.isModalFiltersOpen = state;
    }
    // только в адаптивной версии
    @action
    setIsVisiblePostFilterMenu(isVisible: boolean): void {
        this.isPostfilterMenuVisible = isVisible;
    }

    @action
    setHotelTab(tab: HotelTabs): void {
        this.currentHotelTab = tab;
    }

    @action
    setHotelReviewTab(tab: SourceHotelReview): void {
        this.currentHotelReviewTab = tab;
    }

    @action
    setAdaptiveType(type: AdaptiveType): void {
        this.adaptiveType = type;
    }

    @action
    setHotelRoomsAdaptiveType(type: HotelRoomsAdaptiveType): void {
        this.hotelRoomsAdaptiveType = type;
    }

    @action
    setSearchFormAdaptiveType(type: SearchFormAdaptiveType): void {
        this.searchFormAdaptiveType = type;
    }

    @action
    setPostFiltersAdaptiveType(type: PostFiltersAdaptiveType): void {
        this.postFiltersAdaptiveType = type;
    }

    @action
    setIsExtraPayPopupVisible(isVisible: boolean): void {
        this.isExtraPayPopupVisible = isVisible;
    }

    @action
    setIsExtraPayPopupCloseTimerActive(isActive: boolean): void {
        this.isExtraPayPopupCloseTimerActive = isActive;
    }

    @action
    setHotelDescriptionOpen(isOpen: boolean): void {
        this.isHotelDescriptionOpen = isOpen;
    }

    @action
    setSelectedPostFilterTab(tab: TabsType): void {
        this.selectedPostFilterTab = tab;
    }

    @action
    setIsHotelOnMapOpen(value: boolean): void {
        this.isHotelOnMapOpen = value;
    }

    @action
    setIsHotelFacilitiesOpen(value: boolean): void {
        this.isHotelFacilitiesOpen = value;
    }

    @action
    setOpenPopupRoomId(roomId: number | null): void {
        this.openPopupRoomId = roomId;
    }

    openExtraPayPopup(): void {
        window.clearTimeout(this.extraPayPopupTimer);
        this.setIsExtraPayPopupVisible(true);
        this.setIsExtraPayPopupCloseTimerActive(true);
        this.extraPayPopupTimer = window.setTimeout(() => {
            if (this.isExtraPayPopupCloseTimerActive) {
                this.closeExtraPayPopup();
            }
        }, 5000);
    }

    closeExtraPayPopup(): void {
        window.clearTimeout(this.extraPayPopupTimer);
        this.setIsExtraPayPopupVisible(false);
        this.setIsExtraPayPopupCloseTimerActive(false);
    }
}
